
<app-breadcrumb [title]="'General'" [items]="['Vehiculos']" [active_item]="'General'"></app-breadcrumb>
<div class="container-fluid">
<div class="card">
 <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-list me-2"></i>
      <h5 class="mb-0"><strong>LISTADO DE GENERAL DE VEHÍCULOS</strong></h5>
    </div>
  <div class="card-body custom-datatable noscroll">
    <div class="row mb-12">
       <div class="col-sm-12 col-md-3 ms-auto"> 
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Buscar....."
            [(ngModel)]="searchText"
            (input)="filterData()"
          />
          <span class="input-group-text">
            <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
          </span>
        </div>
      </div>
    </div>
    
    
    <div class="custom-datatable table-responsive mt-4">
      <table class="table table-hover table-bordered" id="tblAfiliadosActivos">
         <thead class="bg-primary">
          <tr>
           <th class="text-center" style="cursor: pointer;" (click)="sortData('placa')">
  <strong>PLACA</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'placa' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'placa' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'placa'
  }"></i>
</th>

<th class="text-center" style="cursor: pointer;" (click)="sortData('interno')">
  <strong>INT.</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'interno' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'interno' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'interno'
  }"></i>
</th>

<th class="text-center" style="cursor: pointer;" (click)="sortData('marca')">
  <strong>MARCA</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'marca' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'marca' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'marca'
  }"></i>
</th>

<th class="text-center" style="cursor: pointer;" (click)="sortData('modelo')">
  <strong>MODELO</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'modelo' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'modelo' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'modelo'
  }"></i>
</th>

<th class="text-center" style="cursor: pointer;" (click)="sortData('clase')">
  <strong>CLASE</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'clase' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'clase' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'clase'
  }"></i>
</th>

<th class="text-center" style="cursor: pointer;" (click)="sortData('cc')">
 <strong>CC PROPIETARIO</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'cc' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'cc' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'cc'
  }"></i>
</th>

<th class="text-center" style="cursor: pointer;" (click)="sortData('propietario')">
  <strong>PROPIETARIO</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'propietario' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'propietario' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'propietario'
  }"></i>
</th>


           <!--  <th class="text-center" >SUCURSAL</th> -->
        <th class="text-center" style="cursor: pointer;" (click)="sortData('relacion')">
  <strong>RELACIÓN</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'relacion' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'relacion' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'relacion'
  }"></i>
</th>

<th class="text-center" style="cursor: pointer;" (click)="sortData('tarjetaOperacion')">
  <strong>ESTADO</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'tarjetaOperacion' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'tarjetaOperacion' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'tarjetaOperacion'
  }"></i>
</th>
<th class="text-center" style="cursor: pointer;" (click)="sortData('tarjetaOperacion')">
  <strong>TAR. OPERACIÓN</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'tarjetaOperacion' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'tarjetaOperacion' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'tarjetaOperacion'
  }"></i>
</th>

<th class="text-center px-3" style="cursor: pointer;" (click)="sortData('soat')">
 <strong>SOAT</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'soat' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'soat' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'soat'
  }"></i>
</th>

<th class="text-center" style="width: 150px; cursor: pointer;" (click)="sortData('cda')">
 <strong>CDA</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'cda' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'cda' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'cda'
  }"></i>
</th>

<th class="text-center" style="cursor: pointer;" (click)="sortData('bimestral')">
  <strong>BIMESTRAL</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'bimestral' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'bimestral' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'bimestral'
  }"></i>
</th>

<th class="text-center" style="cursor: pointer;" (click)="sortData('rcc')">
  <strong>RCC</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'rcc' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'rcc' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'rcc'
  }"></i>
</th>

<th class="text-center" style="cursor: pointer;" (click)="sortData('rce')">
 <strong>RCE</strong>
  <i class="fa ms-1" [ngClass]="{
    'fa-sort-up': sortColumn === 'rce' && sortDirection === 'asc',
    'fa-sort-down': sortColumn === 'rce' && sortDirection === 'desc',
    'fa-sort': sortColumn !== 'rce'
  }"></i>
</th>

            <th class="text-center" ><strong>OPCIONES</strong></th>

          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let vehicle of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
            <td class="text-center">{{ vehicle.placa }}</td>
            <td class="text-center">{{ vehicle.interno }}</td>
            <td class="text-center">{{ vehicle.marcas?.marca }}</td>
            <td class="text-center">{{ vehicle.modelo }}</td>
            <td class="text-center">{{ vehicle.tipoVehiculo?.tipos }}</td>
            <td class="text-center">{{ vehicle.Idpropietario }}</td>
            <td class="text-uppercase text-justify">
              {{ vehicle.propietario?.primernombre }} 
              {{ vehicle.propietario?.segundonombre }}
              {{ vehicle.propietario?.papellidos }}
              {{ vehicle.propietario?.seapellidos }}</td>
       
            <!-- <td class="text-center">{{ vehicle.sucursal }}</td> -->
            <td class="text-center">{{ vehicle.tipoRelacion?.relacion  }}</td>
             <td class="text-center">
              <span 
                class="badge" 
                [ngClass]="vehicle.estado == 1 ? 'badge-success' : 'badge-danger'">
                {{ vehicle.estado == 1 ? 'ACTIVO' : 'INACTIVO' }}
              </span>
            </td>

                        <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.tarjetasOperaciones?.[0]?.estadoCalculado.estado)">
                {{ vehicle.tarjetasOperaciones?.[0]?.fecha_vencimiento ? (vehicle.tarjetasOperaciones?.[0]?.fecha_vencimiento | date:'dd-MM-yyyy') : 'Sin fecha' }}
              </span>
            </td>
           
            <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.historialSoat?.[0]?.estadoCalculado.estado)">
                {{ vehicle.historialSoat?.[0]?.vencimiento_soat ? (vehicle.historialSoat?.[0]?.vencimiento_soat | date:'dd/MM/yyyy') : 'Sin fecha' }}
              </span>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.historialCda?.[0]?.estadoCalculado.estado)">
                {{ vehicle.estadoFechas?.historialCda?.[0]?.vcda ? (vehicle.estadoFechas?.historialCda?.[0]?.vcda | date:'dd/MM/yyyy') : 'Sin fecha' }}
              </span>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.historialBimestral?.[0]?.estadoCalculado.estado)">
                {{ vehicle.historialBimestral?.[0]?.proxima_revision ? (vehicle.historialBimestral?.[0]?.proxima_revision | date:'dd/MM/yyyy') : 'Sin fecha' }}
              </span>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.historialContractual?.[0]?.estadoCalculado.estado)">
                {{ vehicle.historialContractual?.[0]?.fecha_vencimientoRCC ? (vehicle.historialContractual?.[0]?.fecha_vencimientoRCC | date:'dd/MM/yyyy') : 'Sin fecha' }}
              </span>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.historialExtraContractual?.[0]?.estadoCalculado.estado)">
                {{ vehicle.historialExtraContractual?.[0]?.fecha_vencimientoRCE ? (vehicle.historialExtraContractual?.[0]?.fecha_vencimientoRCE | date:'dd/MM/yyyy') : 'Sin fecha' }}
              </span>
            </td>
            <!-- Buscar tarjeta correspondiente -->
            <td>
              <div class="action text-center">
                <ul class="list-inline d-flex justify-content-center gap-3">
                  <li class="list-inline-item edit">
                    <a href="javascript:void(0)">
                      <i class="icon-pencil-alt" (click)="editarPersona(vehicle.placa)" ngbTooltip="Editar" *ngIf="auth.hasPermiso('vehiculos.editar')"></i>
                    </a>
                  </li>
                  <li class="list-inline-item delete">
                    <a href="javascript:void(0)">
                      <i class="icon-trash" (click)="avisoInactivarPersona(vehicle.placa)" ngbTooltip="Inactivar" *ngIf="auth.hasPermiso('vehiculos.inactivar')"></i>
                    </a>
                  </li>
                  
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>


    </div>
    <div class="row align-items-center mt-4 g-2">
    <!-- Selector de registros por página -->
    <div class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start">
      <label for="pageSize1" class="me-2 mb-0">Mostrar:</label>
      <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
        <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
      </select>
      <span class="ms-2">registros por página</span>
    </div>

    <!-- Total de registros -->
    <div class="col-12 col-md-4 text-center my-2 my-md-0">
      <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ vehicles.length || 0 }}</b></span>
    </div>

    <!-- Paginador -->
    <div class="col-12 col-md-4 text-center text-md-end">
      <pagination-controls 
        (pageChange)="page1 = $event" 
        [maxSize]="5"
        [directionLinks]="true"
        [autoHide]="true"
        previousLabel="Anterior" 
        nextLabel="Siguiente">
      </pagination-controls>
    </div>

    </div>
    <div class="card-body">
      <div class="btn-showcase text-center">
        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
          (click)="exportarExcel('tblAfiliadosActivos', 'Listado_Afiliados_Activos')">
          <i class="icofont icofont-file-excel"></i> EXCEL
        </button>

        <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="
            exportToPDF(
              'tblAfiliadosActivos',
              'Listado_Afiliados_Activos',
              'Listado de Afiliados Activos'
            )
          ">
          <i class="icofont icofont-file-pdf"></i> PDF
        </button>

        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Crear"
        (click)="CrearVehiculo()">
        <i class="icofont icofont-plus"></i> Crear
      </button>
      </div>
    </div>
  </div>
</div>












  